import React, { FC, MouseEventHandler, useState } from "react";
import { connect, ConnectedProps } from "react-redux";
import { ApplicationState, AppThunkDispatch } from "../../store";
import { Answer } from "../../store/answer";
import * as FeedbackStore from "../../store/feedback";
import { feedbackActionCreators } from "../../actions/feedbackActions";
import FeedbackForm from "./FeedbackForm";
import { FeedbackPolarity } from "./FeedbackPolaritySelector";
import * as FeedbackConstants from "../../constants/feedbackConstants";
import { getUserId } from "../../adalConfig";
import { X } from "react-feather";

type FeedbackProps =
    & ConnectedProps<typeof connector>
    & (
        {
            answer: Answer;
            query: string;
        } | { }
    );

const Feedback: FC<FeedbackProps> = (props) => {

    const { feedbackState } = props;
    const { createFeedback, updateFeedback } = props;

    const [isSubmitted, setIsSubmitted] = useState(false);
    const [lastPolarity, setLastPolarity] = useState(-1);
    const [extendFeedbackHeight, setExtendFeedbackHeight] = useState(false);
    const [thankYouHeight, setThankYouHeight] = useState(false);

    const handleOnFeedbackPolarityButtonClick = (feedbackPolarity: FeedbackPolarity) => {
        if (feedbackPolarity === FeedbackPolarity.Positive) {
            if ('answer' in props) {
                createFeedback({
                    answer: props.answer.body,
                    answerId: props.answer.id,
                    helpfulFlag: true,
                    question: props.query,
                    navigationLink: window.location.href,
                    userId: getUserId()
                });
            }
            else {
                createFeedback({
                    answer: "",
                    helpfulFlag: true,
                    question: FeedbackConstants.generalFeedbackQuestion,
                    navigationLink: window.location.href,
                    userId: getUserId()
                });
            }
        }
        setLastPolarity(feedbackPolarity);

    }

    const handleOnFeedbackSubmit = (feedback: Omit<FeedbackStore.Feedback, 'id' | 'question' | 'answer' | 'navigationLink'>) => {
        setIsSubmitted(true);
        if (feedback.helpfulFlag && feedbackState.feedback !== undefined) {
            updateFeedback({
                ...feedbackState.feedback,
                ...feedback
            });
        }
        else {
            if ('answer' in props) {
                createFeedback({
                    ...feedback,
                    answer: props.answer.body,
                    answerId: props.answer.id,
                    confidenceScore: props.answer.confidenceScore,
                    question: props.query,
                    navigationLink: window.location.href,
                    userId: getUserId()
                });
            }
            else {
               createFeedback({
                    ...feedback,
                    answer: "",
                    question: FeedbackConstants.generalFeedbackQuestion,
                    navigationLink: window.location.href,
                    userId: getUserId()
                });
            }
        }
        setLastPolarity(-1);
        openThankYouHeight(true);
    }

    const closeFeedbackMenu = (close: boolean) => {
        if (close) {
            setLastPolarity(-1);
        }

    }

    const closeThankYou: MouseEventHandler<HTMLButtonElement> = () => {
        setLastPolarity(-1);
        setExtendFeedbackHeight(false);
        setIsSubmitted(false);
        setThankYouHeight(false);
    }

    const extendFeedbackElementHeight = (extend: boolean) => {
        setExtendFeedbackHeight(extend);
    }

    const openThankYouHeight = (open: boolean) => {
        setExtendFeedbackHeight(false);
        setThankYouHeight(open);
    }

    return (
        <div id="feedbackElement" className={`${thankYouHeight ? " thankYouHeight " : ""} ${extendFeedbackHeight ? " extendFeedbackHeight " : ""} ${lastPolarity != -1 ? " expandFeedback " : ""} `}>
            <section className="content align-center feedback-section">

                {isSubmitted ? (
                    <>
                        <h2>Thank you for your feedback.</h2>
                        <h3>If you have further questions on this topic, please contact your Underwriting Helpdesk for assistance.</h3>
                        <button className={'closeButton ' + (isSubmitted === true ? "" : "hidden")} onClick={closeThankYou}><X /></button>
                    </>
                ) : (
                <>
                    {lastPolarity == -1 ? (
                        <>
                            <h3 id="PromptAdjust">Was this helpful?</h3>
                            <hr className="hrAdjust" />
                        </>
                    ) : (

                        <>

                        </>
                    )}

                    <div className="wrap footerWrapAdjustments">
                        <FeedbackForm isLoading={feedbackState.isLoading} onFeedbackSubmit={handleOnFeedbackSubmit} onFeedbackPolarityButtonClick={handleOnFeedbackPolarityButtonClick} closeMenu={closeFeedbackMenu} extendHeight={extendFeedbackElementHeight} />
                    </div>
                </>
                )}
            </section>
        </div>
    );
}

const mapStateToProps = (state: ApplicationState) => {
    const feedbackState = state.feedback;

    return { feedbackState };
}

const mapDispatchToProps = (dispatch: AppThunkDispatch) => ({
    createFeedback: (feedback: Omit<FeedbackStore.Feedback, "id">) => {
        dispatch(feedbackActionCreators.create(feedback));
    },

    updateFeedback: (feedback: FeedbackStore.Feedback) => {
        dispatch(feedbackActionCreators.update(feedback));
    }
});

const connector = connect(mapStateToProps, mapDispatchToProps);
export default connector(Feedback);
